import { render, staticRenderFns } from "./PharmaceuticsModule.vue?vue&type=template&id=1bcf481b&scoped=true&"
import script from "./PharmaceuticsModule.vue?vue&type=script&lang=js&"
export * from "./PharmaceuticsModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcf481b",
  null
  
)

export default component.exports